import Button from "../../components/Button";

import { download } from "../../js/post";
import { userData } from "../../js/utils";

export default function Reports(props) {
  const report = {
    tituloInforme: "Informe de inventario personalizado",
    subtitulos: [
      "Informe: Inventario a día 12/08/2025 : 18:02",
      "Ópticas: CÁCERES, MÉRIDA, BADAJOZ",
      "Familias: Vista",
      "Proveedores/Marcas: LUXOTTICA SPAIN SL",
    ],
    sumarTablas: true,
    mostrarNumReferencias: true,
    tablas: [
      {
        titulosTabla: ["CÁCERES", "Agente: ANTONIO PÉREZ"],
        extraCabeceras: [
          {
            titulo: "Fecha",
            descripcion: "23/01/2025 : 13:36",
          },
          {
            titulo: "Realizada por",
            descripcion: "ANTONIO PÉREZ",
          },
          {
            titulo: "Motivo",
            descripcion: "PLAN RENOVE",
          },
          {
            titulo: "Tipo",
            descripcion: "VENTA",
          },
          {
            titulo: "Total",
            descripcion: "390,00 €",
          },
          {
            titulo: "Abono",
            descripcion: "390,00 €",
          },
          {
            titulo: "Pendiente",
            descripcion: "0,00 €",
          },
        ],
        cabeceras: [
          {
            titulo: "Codigo",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "EAN/UPC",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "F. Compra",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "Proveedor",
            sumatorio: false,
            tipo: "string",
          },
        ],
        filas: [
          ["40000158", "8056262301388", "09/07/2025", "LUXOTTICA SPAIN SL"],
          ["40000159", "8056262301389", "10/07/2025", "LUXOTTICA SPAIN SL"],
          ["40000160", "8056262301390", "11/07/2025", "LUXOTTICA SPAIN SL"],
        ],
        numReferencias: 10,
      },
      {
        titulosTabla: ["BADAJOZ", "Agente: ESTHER MUÑOZ"],
        extraCabeceras: [
          {
            titulo: "Fecha",
            descripcion: "23/01/2025 : 13:36",
          },
          {
            titulo: "Realizada por",
            descripcion: "ESTHER MUÑOZ",
          },
          {
            titulo: "Motivo",
            descripcion: "PLAN RENOVE",
          },
          {
            titulo: "Tipo",
            descripcion: "VENTA",
          },
          {
            titulo: "Total",
            descripcion: "400,00 €",
          },
          {
            titulo: "Abono",
            descripcion: "350,00 €",
          },
          {
            titulo: "Pendiente",
            descripcion: "50,00 €",
          },
        ],
        cabeceras: [
          {
            titulo: "Codigo",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "EAN/UPC",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "F. Compra",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "Proveedor",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "Marca",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "Modelo",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "Color",
            sumatorio: false,
            tipo: "string",
          },
        ],
        filas: [
          [
            "40000158",
            "8056262301388",
            "12/07/2025",
            "LUXOTTICA SPAIN SL",
            "DOLCE & GABBANA",
            "DG5025",
            "3432",
          ],
          [
            "40000159",
            "8056262301389",
            "13/07/2025",
            "LUXOTTICA SPAIN SL",
            "DOLCE & GABBANA",
            "DG5026",
            "GREEN",
          ],
          [
            "40000160",
            "8056262301390",
            "14/07/2025",
            "LUXOTTICA SPAIN SL",
            "DOLCE & GABBANA",
            "DG5027",
            "BLUE25",
          ],
        ],
        numReferencias: 20,
      },
      {
        titulosTabla: ["MÉRIDA", "Agente: LETICIA LEÓN"],
        extraCabeceras: [
          {
            titulo: "Fecha",
            descripcion: "24/01/2025 : 13:36",
          },
          {
            titulo: "Realizada por",
            descripcion: "LETICIA LEÓN",
          },
          {
            titulo: "Motivo",
            descripcion: "PLAN RENOVE",
          },
          {
            titulo: "Tipo",
            descripcion: "VENTA",
          },
          {
            titulo: "Total",
            descripcion: "500,00 €",
          },
          {
            titulo: "Abono",
            descripcion: "150,00 €",
          },
          {
            titulo: "Pendiente",
            descripcion: "350,00 €",
          },
        ],
        cabeceras: [
          {
            titulo: "Codigo",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "EAN/UPC",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "F. Compra",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "Proveedor",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "Marca",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "Modelo",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "Color",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "Calibre",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "Puente",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "Varilla",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "Material",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "Forma",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "Genero",
            sumatorio: false,
            tipo: "string",
          },
          {
            titulo: "PCN",
            sumatorio: true,
            tipo: "currency",
          },
          {
            titulo: "MCC",
            sumatorio: false,
            tipo: "perc",
          },
          {
            titulo: "PVP",
            sumatorio: true,
            tipo: "currency",
          },
          {
            titulo: "MCV",
            sumatorio: false,
            tipo: "currency",
          },
          {
            titulo: "Stock",
            sumatorio: true,
            tipo: "int",
          },
          {
            titulo: "Stock mínimo",
            sumatorio: false,
            tipo: "int",
          },
        ],
        filas: [
          [
            "40000158",
            "8056262301388",
            "13/07/2025",
            "LUXOTTICA SPAIN SL",
            "DOLCE & GABBANA",
            "DG5025",
            "3432",
            "53",
            "15",
            "140",
            "NYLON",
            "OJO DE GATO",
            "MUJER",
            "425,00 €",
            "120%",
            "650,00 €",
            "70%",
            "3",
            "2",
          ],
          [
            "40000159",
            "8056262301389",
            "14/07/2025",
            "LUXOTTICA SPAIN SL",
            "DOLCE & GABBANA",
            "DG5026",
            "GREEN",
            "53",
            "18",
            "135",
            "PASTA",
            "CUADRADA",
            "UNISEX",
            "550,00 €",
            "130%",
            "1.000,00 €",
            "80%",
            "4",
            "3",
          ],
          [
            "40000160",
            "8056262301390",
            "15/07/2025",
            "LUXOTTICA SPAIN SL",
            "DOLCE & GABBANA",
            "DG5027",
            "BLUE25",
            "53",
            "20",
            "140",
            "TITANIO",
            "AVIATOR",
            "HOMBRE",
            "325,00 €",
            "170%",
            "500,00 €",
            "90%",
            "5",
            "4",
          ],
        ],
        numReferencias: 30,
      },
    ],
  };

  const exportToFile = async (type) => {
    download("GenerarInforme.php", {
      token: userData.token,
      tipo: type,
      informe: report,
    });
  };

  if (!props.show) {
    return <></>;
  }

  return (
    <>
      <div className="patient-data">
        <div className="patient-data-header">
          <span className="header-text">Informes</span>
          <div className="patient-header-buttons"></div>
        </div>
        <div className="patient-data-content">
          <div className="action-bar">
            <div className="action-bar-resume">
              <span>Debug</span>
              <span>|</span>
              <span className="signed-text">Informes</span>
            </div>
            <button
              className="action-bar-return"
              onClick={() => {
                props.onGoBack();
              }}
            >
              <span>Volver</span>
              <img
                src="/images/return.svg"
                loading="lazy"
                alt="Icon"
                className="return-icon"
              />
            </button>
          </div>
          <div className="patient-sections">
            <div className="patient-section">
              <div className="section-content">
                <div className="section-todo-tests">
                  <Button
                    title="Informe CSV"
                    onPress={() => exportToFile("csv")}
                  />
                  <span style={{ marginRight: 10 }} />
                  <Button
                    title="Informe Excel"
                    onPress={() => exportToFile("excel")}
                  />
                  <span style={{ marginRight: 10 }} />
                  <Button
                    title="Informe PDF"
                    onPress={() => exportToFile("pdf")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
